<template>
  <div class="not-found">
    <div class="not-found-content">
      <div class="error-code">404</div>
      <h1>页面未找到</h1>
      <p>抱歉，您访问的页面不存在或已被移除。</p>
      <div class="actions">
        <router-link to="/" class="btn-primary">返回首页</router-link>
        <router-link to="/case" class="btn-secondary">浏览产品</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="scss" scoped>
.not-found {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a75bb 0%, #14679f 100%);

  &-content {
    text-align: center;
    color: #fff;
    padding: 40px;

    .error-code {
      font-size: 120px;
      font-weight: 700;
      line-height: 1;
      margin-bottom: 20px;
      opacity: 0.9;
      text-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    }

    h1 {
      font-size: 32px;
      font-weight: 500;
      margin-bottom: 15px;
    }

    p {
      font-size: 16px;
      opacity: 0.8;
      margin-bottom: 40px;
    }

    .actions {
      display: flex;
      gap: 20px;
      justify-content: center;
      flex-wrap: wrap;

      a {
        display: inline-block;
        padding: 12px 32px;
        border-radius: 25px;
        font-size: 16px;
        text-decoration: none;
        transition: all 0.3s ease;
      }

      .btn-primary {
        background: #fff;
        color: #1a75bb;
        font-weight: 600;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }
      }

      .btn-secondary {
        border: 2px solid rgba(255, 255, 255, 0.5);
        color: #fff;

        &:hover {
          background: rgba(255, 255, 255, 0.1);
          border-color: #fff;
          transform: translateY(-2px);
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .not-found-content {
    .error-code {
      font-size: 80px;
    }

    h1 {
      font-size: 24px;
    }
  }
}
</style>
